import Vue from 'vue'
import App from './App'
import router from './router'

import { OAuth } from './services/oauth'
import { container } from './services/container'
import { Repository } from './services/Repository'

import { User } from './core/User'
import { Order } from './core/Order'

import { getParameterByName, urlB64ToUint8Array } from './assets/js/main.js'
import { ProviderLoader } from './bootstrap/ProviderLoader'

import * as Cookies from 'js-cookie'
import Notifications from 'vue-notification'
import VueLocalStorage from 'vue-localstorage'
import BootstrapVue from 'bootstrap-vue'
import VueGAPI from 'vue-gapi'

import ProgressiveImage from './components/Parts/ProgressiveImage'
import LoadingSpin from './components/Parts/LoadingSpin'

import CTA from './components/Elements/CTA'
import LoadingPlaceholder from './components/Parts/LoadingPlaceholder'
import ModalContainer from './components/Parts/ModalContainer'

import { appViewPosition } from './mixins/appViewPosition' 
import { webview } from './mixins/webview' 

import bugsnag from '@bugsnag/js'
import bugsnagVue from '@bugsnag/plugin-vue'

import Geocoder from "@pderas/vue2-geocoder"

import SliderQ from 'slider-q'
import PopupWidget from 'popup-widget-q'

import { i18n } from './services/localization'

import { configStore } from './store/configStore'
import vuetify from '@/plugins/vuetify'
import { dataLayer } from './mixins/dataLayer'
import { SourceManager } from './services/SourceManager'
import { UserProvider } from './providers/UserProvider'

var process = {
	env: {
		API_URL:"https://api.quomi.it/v1",
		FACEBOOK_OAUTH_ENABLED:1,
		FACEBOOK_OAUTH_CLIENT_ID:"455049681498157",
		FACEBOOK_OAUTH_CLIENT_SECRET:"1ac9fbdfaa4fcbc149984e6a81e55b63",
		FACEBOOK_OAUTH_REDIRECT_URI:"https://quomi.it/oauth/facebook/token",
		STRIPE_KEY:"pk_live_Ph7f5ZJLkem7zqw17NEAXnZQ",
		REDIR_URL:"https://quomi.it",
		BASE_URL:"https://quomi.it",
		ADMIN_URL:"http://admin.quomi.it/admin",
		DOMAIN:"quomi.it",
		FRESHDESK_KEY:"udTZSFu6vYYo351plpj6",
		FRESHDESK_DOMAIN:"terrj",
		APP_SERVER_KEY:"BCUtcPOOsSOOryVYFfOeSS2It3bb0ZOV+wpXUyw+ooWOrX9/ffDtSFosfnOyDmUPHny/y+Dx7wEt+rG63tcJUUA="
	}
}


window.serviceContainer = container;

Vue.use(SliderQ)
Vue.use(PopupWidget)

Vue.use(Geocoder, {
    defaultCountryCode: 'IT', // e.g. 'CA'
    defaultLanguage:    null, // e.g. 'en'
    defaultMode:        'lat-lng', // or 'lat-lng'
    googleMapsApiKey:   process.env.VUE_APP_GOOGLE_MAP_KEY
})

require('dotenv').config()

if (process.env.NODE_ENV !== 'development') {
	if (process.env.VUE_APP_BUGSNAG_API_KEY) {
		const bugsnagClient = bugsnag({
			apiKey: process.env.VUE_APP_BUGSNAG_API_KEY,
			metaData: {
			  clientVersion: process.env.VUE_APP_TIMESTAMP,
			  client: (typeof Android !== "undefined" && Android !== null) ? 'APP (webview Android)' : 'desktop/mobile'
			},
			beforeSend: function (report) {
			    report.metaData = {
			      custom: {
			      	...bugsnagClient.metaData,
			      	...{ quomiUserId: container && container.get('user') ? container.get('user').id : 'no data' }
			      }
			    }
			}
		})
		bugsnagClient.use(bugsnagVue, Vue)
		container.set('bugsnagClient', bugsnagClient)
	}
}

Vue.use(BootstrapVue)
Vue.use(VueLocalStorage)
Vue.use(Notifications)

const apiConfig = {
	apiKey: 'AIzaSyAteLA_KQLawrOId2q7VxISQwIlSWtVpmQ',
	clientId: '305491188209-jfu15boja7pkbqmc68u98bmb6v3hn9c0.apps.googleusercontent.com',
	discoveryDocs: ['https://sheets.googleapis.com/$discovery/rest?version=v4'],
	scope: 'https://www.googleapis.com/auth/contacts.readonly'
	// see all available scopes here: https://developers.google.com/identity/protocols/googlescopes'
}

Vue.http.interceptors.push(function(request) {
	// modify query
	var date = new Date()

  if (request.params) {
    request.params['t'] = date.getTime()/1000|0
  }


	// modify headers
	if (request.url.includes(process.env.VUE_APP_API_URL)) {
		request.headers.set('X-CLIENT-VERSION', process.env.VUE_APP_TIMESTAMP) 
	}
})

Vue.use(VueGAPI, apiConfig)

Vue.config.productionTip = false

var CookieManager = function () {

	// TODO with .env
	const CORDOVA = process.env.VUE_APP_DEVICE
	var self = this

	this.set = function (name, value, expires) {
		if(!expires) {
			expires = 365
		}
		
		if (CORDOVA) {
			return localStorage.setItem(name, value)
		}

		return Cookies.set(name, value, { domain: this.getDomain(), expires: expires })
	}

	this.get = function (name, value) {
		// why param 'value' is here?

		if (CORDOVA) {
			return localStorage.getItem(name)
		}

		return Cookies.get(name, value)
	}

	this.remove = function (name) {
		if (CORDOVA) {
			return localStorage.removeItem(name)
		}

		return Cookies.remove(name, { domain: this.getDomain() })
	}

	this.getDomain = function () {
		let host = window.location.hostname;

		host = host.replace("www.", "") // remove www to avoid double cookies

		return host;
	}

	this.exists = function (name) {
		if (CORDOVA) {
			return typeof localStorage.getItem(name) !== 'undefined'
		}

		return typeof self.get(name) !== 'undefined'
	}
}

container.set('source', new SourceManager());
container.set('freshdesk_key', process.env.VUE_APP_FRESHDESK_KEY)
container.set('freshdesk_domain', process.env.VUE_APP_FRESHDESK_DOMAIN)

container.set('services.oauth', new OAuth())
container.set('services.cookies', new CookieManager())
container.set('admin_url', process.env.VUE_APP_ADMIN_URL)

Vue.component('loading-placeholder', LoadingPlaceholder)
Vue.component('progressive-image', ProgressiveImage)
Vue.component('modal-container', ModalContainer)
Vue.component('loading-spin', LoadingSpin)
Vue.component('CTA', CTA)

Vue.filter('priceFilter', function (value) {
  if (value == NaN) {
  	value = 0;
  }
  
  if (value === null || value === undefined) return ''
  return `€ ${parseFloat(value).toFixed(2).toString().replace('.', ',')}`
})

Vue.mixin(appViewPosition)

Vue.prototype.$mq = {
	_vm: new Vue({
		data: {
			windowWidth: window.innerWidth,
			isOnline: navigator.onLine,
			isOffline: !navigator.onLine,
		},
		created () {
			window.addEventListener('resize', () => {
				this.windowWidth = window.innerWidth
			})

			const updateOnlineStatus = (event) => {
				this.isOnline = navigator.onLine
				this.isOffline = !navigator.onLine
			}

			window.addEventListener('DOMContentLoaded', function() {
				window.addEventListener('online', updateOnlineStatus)
				window.addEventListener('offline', updateOnlineStatus)
			})
		}
	}),
	isOnline () {
		return this._vm.$data.isOnline
	},
	isOffline () {
		return this._vm.$data.isOffline
	},
	isDesktop () {
		return this._vm.$data.windowWidth > 1024
	},

	isPwa () {
		const isInStandaloneMode = () => (window.matchMedia('(display-mode: standalone)').matches)
		return isInStandaloneMode()
	},

	isWV () {

		if (localStorage.getItem('force-app') == 1) {
			return true;
		}
		
		if (typeof Android !== "undefined" && Android !== null) {
            return true
        } else {
        	return process.env.VUE_APP_DEVICE
        }
	},

	isIOS () {
		return /^(iPhone|iPad|iPod)/.test(navigator.platform)
	}
}	

var AuthProvider = function (next) {

  next();

	var cookies = container.get('services.cookies')


	getParameterByName('coupon') && cookies.set('coupon', getParameterByName('coupon'))
	getParameterByName('ref_invite') && cookies.set('ref_invite', getParameterByName('ref_invite'))
	getParameterByName('ref') && cookies.set('ref', getParameterByName('ref'))
	getParameterByName('aff_track') && cookies.set('aff_track', getParameterByName('aff_track'))
	getParameterByName('aff_source') && cookies.set('aff_source', getParameterByName('aff_source'))
	getParameterByName('utm_medium') && cookies.set('utm_medium', getParameterByName('utm_medium'))
	getParameterByName('utm_source') && cookies.set('utm_source', getParameterByName('utm_source'))
	getParameterByName('utm_name') && cookies.set('utm_name', getParameterByName('utm_name'))
	getParameterByName('utm_campaign') && cookies.set('utm_campaign', getParameterByName('utm_campaign'))

	var authToken = getParameterByName('auth_token')
	
	if (authToken) cookies.set('auth_token', authToken)

	if (!cookies.exists('referrer')) cookies.set('referrer', document.referrer)

	next()
}

var ServiceWorkerProvider = function (next) {
	if (!('serviceWorker' in navigator)) {
		next()
		return
	}
	
	navigator.serviceWorker.register('/service-worker.js')

	.then(function (registration) {
     	var appKey = urlB64ToUint8Array(process.env.VUE_APP_APP_SERVER_KEY)
     	var options = {
	    	userVisibleOnly: true,
	    	applicationServerKey: appKey
	    }

 		navigator.serviceWorker.addEventListener('message', function (event) {
	    })

	    window.swRegistration = registration
 	})

 	.then(r => {
 		next()
 	})

 	.catch(error => {
 		next()
 	})
}

var GoogleTagManagerProvider = function (next) {

	  container.set('gtc', dataLayer);
	  container.get('gtc').ini();


	if (container.get('source').getValue() === 'galbani') {
		console.log("GTM: Galbani");
    
		(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
	    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
	    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
	    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
	    })(window,document,'script','dataLayer','GTM-TN8DHB');
    

	} else if (container.get('source').getValue() === 'bennet') {
		console.log("GTM: Bennet");

		(function(a,s,y,n,c,h,i,d,e){s.className+=' '+y;h.start=1*new Date;
			h.end=i=function(){s.className=s.className.replace(RegExp(' ?'+y),'')};
			(a[n]=a[n]||[]).hide=h;setTimeout(function(){i();h.end=null},c);h.timeout=c;
			})(window,document.documentElement,'async-hide','dataLayer',4000,
			{'GTM-WVJ8G97':true});

		(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
	    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
	    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
	    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
	    })(window,document,'script','dataLayer','GTM-WVJ8G97');

      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-TJPQ6C4');

	} else {
		if (document.location.hostname.search("quomi.it") !== -1) {

			console.log("GTM: Quomi");

			(function(a,s,y,n,c,h,i,d,e){s.className+=' '+y;h.start=1*new Date;
			h.end=i=function(){s.className=s.className.replace(RegExp(' ?'+y),'')};
			(a[n]=a[n]||[]).hide=h;setTimeout(function(){i();h.end=null},c);h.timeout=c;
			})(window,document.documentElement,'async-hide','dataLayer',4000,
			{'GTM-NB8PBN6':true});

			(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
			new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
			j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
			'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
			})(window,document,'script','dataLayer', "GTM-NB8PBN6");
		}
	}



  next();
}

var SourceServiceProvider = function (next) {
	if (window.location.hostname.indexOf("galbani") > -1) {
		window.location.href = "https://quomi.it";
		return 
	}

  var cookies = container.get("services.cookies");

  if (cookies.get('user_source_track')) {
    container.get('source').updateValue(cookies.get('user_source_track'));
  }

  next()
}


var BennetServiceProvider = function (next) {

	var cookies = container.get('services.cookies')

  if(window.location.hostname.indexOf("bennet") > -1) {
/* 		cookies.remove('token') */
		container.get('services.oauth').providerSignInCode('bennet', {})
		.finally(e => {
			next()
		})
 	} else {
 		next()
 	}
}

var ThirdPartySourceServiceProvider = function (next) {

  if(window.location.hostname.indexOf("galbani") > -1) {
    container.get('source').updateValue('galbani')
  }
  
  if(window.location.hostname.indexOf("bennet") > -1) {
    container.get('source').updateValue('bennet');
  }


  next()
}

var ConfigProvider = function (next) {
	configStore.loadConfig()
	.then(response => {
		window.config = configStore.state.config
		next()
	})

	.catch(_ => {
		next()
	})
}


var VueProvider = function (next) {
	(() => {
		container.set('vue', new Vue({
			i18n,
			el: '#app',
			router,
			template: '<App/>',
			components: { App },
			data: {
				container: container,
        source: container.get('source').getValue(),
				user: container.get('user'),
				config: {
					googlePlaces: true
				},
        repository: new Repository()
			},
			
			mixins: [
				webview
			],
      created () {
        window.addEventListener('source-update', (e) => {
          let user = container.get('user');
          if (user) {
            user.source = e.detail
          }
          this.source = e.detail
        })
      },
			methods: {
				updateUser (user) {

					if (user && user.order) {
						user.order = new Order(user.order);	
					}

					user ? container.set('user', user) : container.set('user', null)

					this.user = user
					window.user = this.user

				}
			},
			vuetify	
		}))
	})()

	next()
}

var pl = new ProviderLoader()
pl.addProviders([
	SourceServiceProvider,
  ThirdPartySourceServiceProvider,
  GoogleTagManagerProvider,
	//AuthProvider,
	ConfigProvider,
	BennetServiceProvider,
	//UserProvider,
	ServiceWorkerProvider,
	VueProvider
])
pl.execute(0)


